<template>
  <v-app>
    <v-progress-linear
        :indeterminate="loading"
        height="2" color="orange"
        style="margin: 0;z-index: 9999;position: fixed;"
    />
    <router-view></router-view>
    <!-- -->
    <v-snackbar
        :timeout="snackbar.timeout"
        :top="true"
        :multi-line="true"
        v-model="snackbar.show"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn flat icon class="mx-0" @click.native="snackbar.show = false">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="timeout" persistent max-width="320">
      <v-card>
        <v-card-text>
          <p>会话超时，请输入 <span class="primary--text">{{ name }} ({{ username }})</span> 的密码</p>
          <v-text-field
              type="password"
              label="密码"
              :hint="msg"
              v-model="passwd"
              persistent-hint
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="checkPasswd">确定</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

import md5 from 'md5'

export default {
  name: 'App',
  data() {
    return {
      loading: false,
      // 上次操作的时间戳
      lastTimestamp: Date.now(),
      timeout: false,
      passwd: '',
      msg: '',
      tryNum: 0,

      snackbar: {
        show: false,
        timeout: 10000,
        text: '',
        color: 'error'
      }
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'name',
      'username',
      'password'
    ])
  },

  // 注册异步请求响应的公共回调
  created() {
    // 响应拦截器
    const vm = this;
    Vue.axios.interceptors.response.use(
        function (response) {
          // 正常响应
          return response;
        },
        function (error) {
          // Do something with response error
          // console.log(error);
          const msg = error.response.data.message || "";
          vm.snackbar.text = "服务器错误[" + error.response.status + "]: " + msg;
          vm.snackbar.show = true;
          return Promise.reject(error);
        }
    );

    // 请求拦截器
    Vue.axios.interceptors.request.use(cfg => {
      // 更新最后一次操作的时间
      vm.lastTimestamp = Date.now();
      return cfg
    }, err => {
      window.console.log(err)
    })

    this.$router.beforeEach(
        (to, from, next) => {
          // console.log("in App $router.beforeEach");

          this.loading = true;
          next();
        });

    this.$router.afterEach(
        () => {
          this.loading = false;
        });

    // 10 秒钟检查一次会话是否超时
    setInterval(this.isBusy, 10000);
  },
  methods: {
    checkPasswd() {
      if (this.password === md5(this.passwd)) {
        this.lastTimestamp = Date.now();
        this.timeout = false;
        this.passwd = '';
        this.msg = '';
      } else {
        this.msg = '密码错误，请重试！'
      }
    },
    isBusy() {
      // 会话超时 30 分钟
      let timeout = (Date.now() - this.lastTimestamp) > 30 * 60 * 1000;
      if (timeout) {
        // window.console.log('timeout');
        this.timeout = true
      }
    }
  }
}
</script>
<style>
.application {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>

